module.exports = __webpack_public_path__ + "img/jp.3e72015c.svg";